"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PitcherResponseStatus = void 0;
var PitcherResponseStatus;
(function (PitcherResponseStatus) {
    PitcherResponseStatus[PitcherResponseStatus["RESOLVED"] = 0] = "RESOLVED";
    PitcherResponseStatus[PitcherResponseStatus["REJECTED"] = 1] = "REJECTED";
})(PitcherResponseStatus || (exports.PitcherResponseStatus = PitcherResponseStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdG9jb2wuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvdG9jb2wudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBa0JBLElBQVkscUJBR1g7QUFIRCxXQUFZLHFCQUFxQjtJQUMvQix5RUFBWSxDQUFBO0lBQ1oseUVBQVksQ0FBQTtBQUNkLENBQUMsRUFIVyxxQkFBcUIscUNBQXJCLHFCQUFxQixRQUdoQyJ9